<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#vitamine1">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Vitamine și minerale</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black"></span></div>

    </div>

    <div id="vitamine1" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina A</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">422 µg-RE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">58 µg-RE</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina D</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">11 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.45 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina E*</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">8.8 mg TE</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.2 mg TE</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina K</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">41 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">5.6 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina C</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">60 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">8.2 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Tiamină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.48 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.07 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Riboflavină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.99 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.14 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Niacină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.1 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.43 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B6</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.403 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.055 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Folat</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">98 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">13 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Vitamina B12</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">1.2 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.16 µg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Biotină</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">13 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">1.8 µg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Acid pantotenic</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.834 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.525 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Sodiu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">162 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">22.1 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Potasiu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">609 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">83 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Clorură</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">403 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">55 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Calciu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">426 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">58 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fosfor*</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">243 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">33 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Magneziu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">48 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">6.6 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fier</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.9 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.53 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Zinc</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">3.5 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.48 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Cupru</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.365 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.050 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Mangan</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">0.024 mg </span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">0.003 mg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Fluorură*</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">≤0,043 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">≤0,0059 mg</span></div>
      </div>
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Seleniu</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">18 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">2.5 µg</span></div>
      </div>

      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Iod</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">92 µg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">13 µg</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vitamine",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
